import React from 'react';
import { useSelector } from 'react-redux';
import { PieGraph } from '@gerdau/hefesto-mais-web';
import { GraphContainer } from './styles';
import { ApplicationState } from '../../../../store';

interface ResultGraphProps {
  percentage: number;
  setPercentage: (percentage: number) => void;
}
const ResultGraph: React.FC<ResultGraphProps> = ({
  percentage,
  setPercentage
}) => {
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const totalTonnes =
    loyalty.rewards.error || loyalty.rewards.loading
      ? 0
      : loyalty.rewards.total.total_tonne;
  const simulatedCoins =
    loyalty.simulate.error || loyalty.simulate.loading
      ? 0
      : loyalty.simulate.simulation_tonne;

  const baseData = loyalty.goal.monthly_goal
    .map((item) => {
      const parsedDate = new Date(item.month);
      return {
        value: item.target,
        order: parsedDate
      };
    })
    .sort((item1, item2) => item1.order.getTime() - item2.order.getTime())
    .slice(-1);
  const monthGoal = baseData[0].value;
  const getNeededCoins = () => {
    const auxGoal = monthGoal - totalTonnes - simulatedCoins;
    if (auxGoal > 0) {
      return auxGoal;
    } else {
      return 0;
    }
  };

  const getCoinPercentage = () => {
    const finalPercentage = ((totalTonnes + simulatedCoins) * 100) / monthGoal;
    setPercentage(Number(finalPercentage.toFixed(1)));
    return percentage + '%';
  };

  const getCoinPercentageClass = () => {
    return (
      'porcentagem-pontos-' + getCoinPercentage().toString().length + '-digit'
    );
  };
  return (
    <GraphContainer>
      <span className="subtitle">
        Veja abaixo se você conseguiu atingir a meta mensal
      </span>
      <div className="simulator-graph">
        <span className={'porcentagem-pontos ' + getCoinPercentageClass()}>
          {getCoinPercentage()}
        </span>
        <PieGraph
          colors={[
            {
              tone: '800',
              variant: 'support-02'
            },
            {
              tone: '700',
              variant: 'primary-02'
            },
            {
              tone: '100',
              variant: 'secondary'
            }
          ]}
          dataKey="value"
          dataSource={[
            {
              name: 'Qtd. acumulada ' + totalTonnes + ' toneladas',
              value: totalTonnes
            },
            {
              name: 'Qtd. simulada ' + simulatedCoins + ' toneladas',
              value: simulatedCoins
            },
            {
              name: 'Qtd. para a meta ' + getNeededCoins() + ' toneladas',
              value: getNeededCoins()
            }
          ]}
          graphCX="50%"
          graphCY="50%"
          graphInnerRadius={100}
          graphOuterRadius={150}
          showLegend
        />
      </div>
      <div className="bottom-subtitle">
        <span>
          O preço dos produtos pode variar tornando a simulação uma estimativa
          aproximada
        </span>
      </div>
    </GraphContainer>
  );
};

export default ResultGraph;
